import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { ButtonWrap } from "shared/Button/styled";

export const FirstInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
`;

export const FirstInputWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  border: 1px solid ${colors.GREY_SEMILIGHT};
  border-radius: 5px;
  @media (min-width: 769px) {
    padding: 5px 10px;
  }
`;

export const FirstButtonsWrap = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${ButtonWrap} {
    flex: 0 0 49%;
  }
  @media (min-width: 769px) {
    display: block;
    margin-top: 0px;
    ${ButtonWrap} {
      margin-left: 10px;
    }
  }
`;

export const FirstInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  @media (min-width: 769px) {
    flex-direction: row;
  }
`;

export const CustomDescription = styled.div`
  margin-left: 15px;
`;

export const CustomItemLeft = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const CustomItemRight = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  .icon {
    margin-right: 20px;

    &-delete {
      fill: ${colors.RED};
      stroke: ${colors.RED};
    }
  }
`;

export const CustomIngredientItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0px;
  cursor: pointer;
`;

export const CustomGroceryContent = styled.div`
  padding: 0px 0px 0px 40px;
`;
